export default [
  {
    component: () => import("pages/ExportList.vue"),
    meta: {
      accessLevel: "super",
      title: "Exports",
    },
    name: "exports",
    path: "/exports",
    props: (route) => ({ ...route.params, ...route.query }),
  },
];
